export default __webpack_public_path__ + "static/media/lock.2d1779df.svg";